module.exports = __webpack_public_path__ + "static/media/iconListToken7.628e982d.svg";